import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { verifyEmail } from '../../API/functions';
import { useDispatch } from 'react-redux';
import { setVerifyEmailModal } from '../../redux/slices/userSlice';


export const useVerifyEmail = ({onSuccess}) => {
  const dispatch =useDispatch()
  const { mutate,isPending } = useMutation({
    mutationFn: (vars) => verifyEmail(vars),
    onSuccess: (result) => {
      dispatch(setVerifyEmailModal(true))
      toast.success(result.message);
      if (onSuccess) onSuccess(); 
    },
    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { mutate,isPending };
};
